/**
 * Safe filter for Ant Design Select search (v5-compatible).
 * option.children is often a React node, not a string.
 */
export function filterSelectOption(input, option) {
  const search = String(input ?? "")
    .trim()
    .toLowerCase();
  if (!search) return true;

  const parts = [
    option?.label,
    typeof option?.children === "string" ? option.children : null,
    option?.value != null ? String(option.value) : null,
  ].filter((p) => p != null && String(p).length > 0);

  const text = parts.join(" ").toLowerCase();
  return text.includes(search);
}
